import React from "react";
import LazyLoad from "@custom/LazyLoad";

const ContentImage = ({ title, description, image }) => {
	if (!image) return "";
	return (
		<React.Fragment>
			{image.map((img, i) => (
				<LazyLoad key={`image-${i}`}>
					<figure>
						<img
							src={img.secure_url}
							alt={title}
							title={description}
							loading="lazy"
							decoding="async"
						/>
						<figcaption>{title}</figcaption>
					</figure>
				</LazyLoad>
			))}
		</React.Fragment>
	);
};

export default ContentImage;
